import { useEffect, useState, useMemo } from "react";
import StressButton from "../../../components/StressButton";
import Results from "./Results";

const ListenAndClickIIStress = ({numStress, tracks, progress, tab, resultsHandler, nextExercise, setProgress, nextTab}) => {
    const [buttonState, setButtonState] = useState(false); // pair buttons are disabled when false
    const [registerHit, setRegisterHit] = useState(false);
    const [animatePulse, setAnimatePulse] = useState(Array(numStress).fill(false));
    const [animateRight, setAnimateRight] = useState(Array(numStress).fill(false));
    const [animateWrong, setAnimateWrong] = useState(Array(numStress).fill(false));
    const [track, setTrack] = useState(0);
    const [scores, setScores] = useState(progress[tab] ? progress[tab] : []);
    const [results, setResults] = useState({'results': [], 'value': []});
    const [playState, setPlayState] = useState(false); // sounds are played when true
    const [resultPage, setResultPage] = useState(false);
    const [start, setStart] = useState(false);

    let target = tracks[track];
    let audio0 = useMemo(() => new Audio(target.audio),[target]);

    const PlayNext = () => {
        setTimeout(() => {
            if (track < tracks.length - 1) {
                setTrack(track + 1);
                setButtonState(false);
                setPlayState(true);
                setRegisterHit(false);
                const array = Array(numStress).fill(false);
                setAnimatePulse(array);
                setAnimateRight(array);
                setAnimateWrong(array);
            } else {
                setResultPage(true);
                resultsHandler(results);
            }
        }, 2300);
    }

    const PushResult = (b) => {
        let r2 = results;
        r2.results.push({
            eval: b,
            target: target
        });
        r2.value.push(b);
        setResults(r2);
    }

    const Play = (button) => {
        setRegisterHit(true);
        let array = Array(numStress).fill(false);
        setAnimatePulse(array);
        array[button] = true;
        if (target.MainStressSyllable === button + 1) {
            PushResult(true);
            setAnimateRight(array);
            setScores([...scores, 1]);
        } else {
            PushResult(false);
            setAnimateWrong(array);
            setScores([...scores, 0]);
        }
        PlayNext();
    }

    const Button = ({button}) => {
        return <div className="flex flex-col items-center w-full">
            <div>
                <button
                    disabled={!buttonState || registerHit}
                    className={`
                        border-b-4 py-3 px-5 rounded-full font-serif:Times text-3xl font-semibold text-white shadow-md animate__animated my-2 md:my-0
                        ${animatePulse[button] && "animate__pulse"}
                        ${animateRight[button] && "animate__tada bg-green-500 border-green-700 opacity-60"}
                        ${animateWrong[button] && "animate__shakeX bg-red-500 border-red-700 opacity-60"}
                        ${!animateRight[button] && !animateWrong[button] ? "bg-pygblue border-blue-700 hover:bg-blue-500" : ""}`
                    }
                    style={{ '--animate-duration': '1s' }} // Change the duration of the animation here. Default: 1s
                    onClick={() => Play(button)}
                >
                    <StressButton numStress={numStress} mainStress={button} />
                </button>
            </div>
        </div>
    }

    useEffect(() => {
        let mounted = true;

        const handleCanPlayThrough = () => {
            audio0.removeEventListener("canplaythrough", handleCanPlayThrough);
            if (mounted) {
                setTimeout(() => {
                    audio0.play();
                    setAnimatePulse(Array(numStress).fill(true));
                }, 300);
            }
        }

        setAnimatePulse(Array(numStress).fill(false));

        if (playState) {
            setTimeout(() => {
                audio0.addEventListener("canplaythrough", handleCanPlayThrough);
                audio0.addEventListener("ended", () => {
                    setButtonState(true);
                    setPlayState(false);
                });
                audio0.currentTime = 0;
            }, 300);
            setAnimatePulse(Array(numStress).fill(false));
        } else {
            setPlayState(false);
        }

        return () => {
            mounted = false;
            audio0.removeEventListener("ended", () => {setButtonState(true)});
            audio0.pause();
        }
    }, [track, playState]);

    // Tracks the scorers for the exercise
    useEffect(() => {
        setProgress(prevProgress => {
            let newProgress = [...prevProgress];
            newProgress[tab] = scores;
            return newProgress;
        })
    },[scores]);

    if (resultPage) {
        return <div className={`flex flex-col items-center justify-center ${numStress === 2 ? "px-20 pb-10" : "md:px-20"}`}>
            <Results
                results={results.value}
                nextTab={nextTab}
                nextExercise={nextExercise}
            />
        </div>
    }

    return <div className={`flex flex-col items-center justify-center ${numStress === 2 ? "px-20 pb-10" : "md:px-20"}`}>
        {/* PLAY BUTTON */}
        <div className='mx-auto pt-7 md:pb-7 pb-10'>
            <button 
                disabled={playState || registerHit}
                className={`bg-pygblue rounded-3xl p-8 border-b-4 shadow-md
                ${playState || registerHit
                    ? "opacity-40 cursor-default border-transparent" 
                    : "hover:bg-blue-500  opacity-100 border-blue-700 active:translate-y-1 active:ease-in-out active:shadow-xl "}
                `}
                
                onClick={() => {
                    setPlayState(true);
                    setStart(true);
                }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32.00 32.00"
                    fill="white"
                    className={`w-12 h-12 `}
                >
                  <path d="M16,6v20c0,1.1-0.772,1.537-1.715,0.971l-6.57-3.942C6.772,22.463,5.1,22,4,22H3c-1.1,0-2-0.9-2-2 v-8c0-1.1,0.9-2,2-2h1c1.1,0,2.772-0.463,3.715-1.029l6.57-3.942C15.228,4.463,16,4.9,16,6z M26.606,5.394 c-0.781-0.781-2.047-0.781-2.828,0s-0.781,2.047,0,2.828C25.855,10.3,27,13.062,27,16s-1.145,5.7-3.222,7.778 c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586C29.439,23.773,31,20.007,31,16 S29.439,8.227,26.606,5.394z M22.363,9.636c-0.781-0.781-2.047-0.781-2.828,0s-0.781,2.047,0,2.828C20.479,13.409,21,14.664,21,16 s-0.52,2.591-1.464,3.535c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 C24.064,20.664,25,18.404,25,16S24.063,11.336,22.363,9.636z"></path>
              </svg>
            </button>
        </div>

        {/* CHOICES */}
        <div className={`${numStress === 2 && "md:w-4/5 "}w-full grid grid-cols-1 md:grid-cols-3 items-center justify-center text-center md:py-5 opacity-${start ? "100" : "40"}`}>
                {numStress === 2 ? <>
                    <Button button={0} />
                    <h1 className="text-gray-500 font-mono font-bold"> or </h1>
                    <Button button={1} />

                    {/* Translations */}
                    <p className={` hidden md:block col-start-1 break-word text-sm mt-2 border-t-2 pt-1 text-gray-500 ${
                        registerHit && target.MainStressSyllable === 1?
                        'opacity-100'
                        :'opacity-0'
                    }`}>
                        {target.translation}
                    </p>

                    <p className={`hidden md:block col-start-3 break-word text-sm mt-2 border-t-2 pt-1 text-gray-500 ${
                        registerHit && target.MainStressSyllable === 2?
                        'opacity-100'
                        :'opacity-0'
                    }`}>
                        {target.translation}
                    </p>
                </> : [...Array(numStress)].map((_, i) => <Button button={i} />)}
        </div>
    </div>
}

export default ListenAndClickIIStress;